export const formatCampaignsResponse = (response) => ({
    success: response.success,
    data: formatRows(response.data, response.series),
    columns: formatColumns(response.series),
    totalCount: response.totalCount,
});
const formatRows = (data, series) => data.map(row => {
    const record = Object.fromEntries(row.map((cell, idx) => [series[idx].key, cell]));
    return record;
});
const formatColumns = (series) => series.map(s => ({ key: s.key, label: s.name, type: s.type }));
